import styled from 'styled-components'

export const ListItem = styled.ul`
      padding-left: 0px;
`
